import { Box, Typography } from "@outschool/backpack";
import { ClassOfferingTimeRange } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import { dayjs } from "@outschool/time";
import { useSession } from "@outschool/ui-auth";
import { TrackedButton } from "@outschool/ui-components-shared";
import { Screen } from "@outschool/ui-utils";
import React from "react";
import ReactDOM from "react-dom";

const formatTimeRange = (
  classOfferingTimeRange: ClassOfferingTimeRange,
  userTimeZone: string,
): string => {
  const { start, end } = classOfferingTimeRange;

  const startTime = dayjs.tz(start, "hh:mm:ss", userTimeZone);
  const endTime = dayjs.tz(end, "hh:mm:ss", userTimeZone);

  const sameAmPm = startTime.format("a") == endTime.format("a");

  return `${startTime.format(sameAmPm ? "h:mm" : "LT")} - ${endTime.format(
    "LT zz",
  )}`;
};

export function StickyMobileUpcomingClassFooter({
  buttonText,
  handleButtonClick,
  classOfferingTimeRange,
  hasUpcomingListings,
}: {
  buttonText: string;
  handleButtonClick: () => void;
  classOfferingTimeRange: ClassOfferingTimeRange | null;
  hasUpcomingListings: boolean;
}): React.ReactPortal {
  const isMobile = Screen.useIsMobile();
  const { userTimeZone } = useSession();
  const { t } = useTranslation(
    "client\\components\\teacher\\TeacherProfile\\StickyMobileUpcomingClassFooter",
  );

  const text = hasUpcomingListings ? (
    classOfferingTimeRange ? (
      <>
        <div>{t("Classes offered:")}</div>
        <div>
          {t("{{timeRange}}", {
            // @ts-ignore TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
            timeRange: formatTimeRange(classOfferingTimeRange, userTimeZone),
          })}
        </div>
      </> // teacher has upcoming scheduled classes
    ) : (
      t`Classes offered at your own pace`
    ) // teacher has flex classes
  ) : (
    t`Classes offered by request`
  ); // teacher has requestable classes

  // @ts-ignore TS(2322): Type 'ReactPortal | null' is not assignable to typ... Remove this comment to see the full error message
  return !isMobile
    ? null
    : ReactDOM.createPortal(
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
          }}
        >
          <Box
            flex
            sx={{
              height: "80px",
              backgroundColor: "common.white",
              boxShadow: "inset 0px 1px 0px #DDDFE3",
              alignItems: "center",
              justifyContent: "space-between",
              columnGap: "0.5em",
              paddingX: "1em",
            }}
          >
            <Typography
              variant="inherit"
              sx={{
                display: "block",
                color: "#6A7482",
                fontSize: "0.875em",
              }}
            >
              {text}
            </Typography>
            <TrackedButton
              trackingName="upcoming_class_footer_button_clicked"
              variant="contained"
              onClick={handleButtonClick}
            >
              <Typography variant="inherit">{buttonText}</Typography>
            </TrackedButton>
          </Box>
        </Box>,
        document.body,
      );
}
